import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddProfessionalReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const ProfessionalismWorkEthicStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tProfReport } = useTranslation("goHire", {
    keyPrefix: "components.reviewCandidateModal.professionalReport",
  });

  const { control } = useFormContext<AddProfessionalReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddProfessionalReviewCandidate }[] = [
    { title: tProfReport("discipline"), description: tProfReport("commitmentToStandards"), fieldName: "discipline" },
    { title: tProfReport("workRate"), description: tProfReport("effortAndConsistency"), fieldName: "workRate" },
    {
      title: tProfReport("integrityEthics"),
      description: tProfReport("transparencyFairnessHonesty"),
      fieldName: "integrityEthics",
    },
    { title: tProfReport("resilience"), description: tProfReport("abilityToRecover"), fieldName: "resilience" },
    {
      title: tProfReport("coachAbility"),
      description: tProfReport("willingnessToLearnAdaptCollaborate"),
      fieldName: "coachAbility",
    },
    {
      title: tProfReport("professionalPresence"),
      description: tProfReport("reputationCredibilityRepresentation"),
      fieldName: "professionalPresence",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default ProfessionalismWorkEthicStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
